import * as rudderanalytics from 'rudder-sdk-js'

const WRITE_KEY = process.env.VUE_APP_RUDDERSTACK_WRITE_KEY
const DATA_PLANE_URL = process.env.VUE_APP_RUDDERSTACK_DATA_PLANE_URL

rudderanalytics.load(WRITE_KEY, DATA_PLANE_URL)

rudderanalytics.ready(() => {
  const isDev = process.env.NODE_ENV === 'development'
  if (isDev) {
    console.log('Rudderstack is all set!!!')
  }
})

function track (event, properties) {
  rudderanalytics.ready(() => {
    rudderanalytics.track(event, properties)
  })
}

function identify (userId, traits) {
  rudderanalytics.ready(() => {
    rudderanalytics.identify(userId, traits)
  })
}

export { track, identify }
